module.exports = __webpack_public_path__ + "img/7.e0213449.jpg";